export var TranslationLanguages = ['en', 'es', 'ja', 'zh', 'ko'];
